import { render, staticRenderFns } from "./ModuleAdd.vue?vue&type=template&id=19d2987a&"
import script from "./ModuleAdd.vue?vue&type=script&lang=js&"
export * from "./ModuleAdd.vue?vue&type=script&lang=js&"
import style0 from "./ModuleAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports